const ComplaintListCtrl = ['$scope', '$filter', '$window', '$rootScope','UserInfo', 'ComplaintAPI', 'Alert', 'WATIUM_DEPARTMENTS', 'AGENT_CODES',
    function ($scope, $filter, $window, $rootScope, UserInfo, ComplaintAPI, Alert, WATIUM_DEPARTMENTS, AGENT_CODES) {
        /***********************************************************************************************************
         * Controller Attributes
         ***********************************************************************************************************/
        var $translate = $filter('translate');

        /***********************************************************************************************************
         * Scope Attributes
         ***********************************************************************************************************/
        $scope.action = 'detail';
        $scope.searchBy = 'search';
        $scope.complaints = [];

        $scope.status = [
                {code: 'CRE', label: $translate('COMPLAINTS.CREATED')},
                {code: 'CLO', label: $translate('COMPLAINTS.CLOSED')}
            ];

        $scope.watiumDepartments = WATIUM_DEPARTMENTS;
        $scope.agent_codes = AGENT_CODES;

        $scope.searchByLabel = $translate('COMPLAINTS.ALL');
        $scope.searchFilters = {
            'contract': $translate('COMPLAINTS.N_CONTRACT'),
            'cups': $translate('COMPLAINTS.CUPS'),
            'id': $translate('COMPLAINTS.IDENTIFIER'),
            'external_code': $translate('COMPLAINTS.WATIUM_CODE'),
            'search': $translate('COMPLAINTS.ALL')
        };

        $scope.searchBy = Object.keys($scope.searchFilters)[0];
        $scope.searchByLabel = $scope.searchFilters[$scope.searchBy];

        $scope.ordering = {
            'id': $translate('COMPLAINTS.IDENTIFIER'),
            'contract': $translate('COMPLAINTS.N_CONTRACT')
        };
        
        $scope.date_filters = {
            complaint_date_range: null,
            date_range_from: null,
            date_range_to: null
        };

        $scope.filters_by_date = [
            { value: "creation_date", description: $translate('COMPLAINTS.CREATION_DATE') },
            { value: "last_status_change", description: $translate('COMPLAINTS.LAST_STATUS_CHANGE') },
            { value: "modification_date", description: $translate('COMPLAINTS.MODIFICATION_DATE') }
        ];

        $scope.filters = {
            search: "",
            id: "",
            status: null
        };

        /***********************************************************************************************************
         * Scope Watchers
         ***********************************************************************************************************/
        $scope.$watch('searchQuery', function (newVal, oldVal) {
            $scope.filters[$scope.searchBy] = newVal;
        });

        $scope.$on("selectedCounterChange", function (e, selectedCounterChange) {
            $scope.counter = selectedCounterChange;
        });
        
        $scope.$watch('searchQuery', function(newVal, oldVal){
            $scope.filters[$scope.searchBy] = newVal;
        });
        $scope.$watchCollection('date_filters', function(newVal, oldVal){
            if (oldVal.complaint_date_range !== null) {
                var sel_option = oldVal.complaint_date_range.value;
                if (oldVal.date_range_from !== null) {
                    $scope.filters[sel_option + "_from"] = null;
                }
                if (oldVal.date_range_to !== null) {
                    $scope.filters[sel_option + "_to"] = null;
                }
            }
            if (newVal.complaint_date_range !== null) {
                sel_option = newVal.complaint_date_range.value;
                if (newVal.date_range_from !== null) {
                    var from_date = newVal.date_range_from;
                    $scope.filters[sel_option + "_from"] = from_date;
                }
                if (newVal.date_range_to !== null) {
                    var to_date = newVal.date_range_to;
                    $scope.filters[sel_option + "_to"] = to_date;
                }
            }
        });

        /***********************************************************************************************************
         * Controller Methods
         ***********************************************************************************************************/

        /***********************************************************************************************************
         * Scope Methods
         ***********************************************************************************************************/
        $scope.setSearchBy = function (val) {
            $scope.filters[$scope.searchBy] = '';
            $scope.searchBy = val;
            $scope.searchByLabel = $scope.searchFilters[val];
            $scope.filters[val] = $scope.searchQuery;
        };

        $scope.deleteComplaint = function ($event) {
            $event.preventDefault();
            $scope.action = 'delete';
        };

        $scope.cancelDeleteComplaint = function ($event) {
            $scope.action = 'detail';
            $event.preventDefault();
        };

        $scope.confirmDeleteComplaint = function (id) {
            ComplaintAPI.deleteComplaint(id).then(function (data) {
                Alert.createAlert('success', $translate('COMPLAINTS.COMPLAINT_DELETED'), true);
                $scope.action = 'detail';
                $rootScope.$broadcast('refreshList');
            }).catch(function (error) {
                $scope.error_message = error.data.__all__[0];
            });
        };

        $scope.showCreateComplaintForm = function () {
            $window.location.href = '/complaints/create';
        };

        $scope.canCreateComplaint = function () {
            return UserInfo.hasPerm('complaints.add_complaint');
        };

        $scope.canViewComplaint = function () {
            return UserInfo.hasPerm('complaints.retrieve_complaint');
        };

        $scope.canDeleteDeleteComplaint = function () {
            return UserInfo.hasPerm('complaints.delete_complaint');
        };

        /***********************************************************************************************************
         * Controller Initialization
         ***********************************************************************************************************/

    }
]

export { ComplaintListCtrl }
